const seoConfig = {
  default: {
    title: "Kosmetikstudio & Parfümerie Sankt Augustin bei Bonn",
    description:
      "Kosmetikstudio und Parfümerie in Sankt Augustin Hangelar bei Bonn: Gesichtsbehandlungen, Make-up, Braut Make-up und persönliche Beratung.",
  },
  pages: {
    home: {
      title: "Kosmetikstudio & Parfümerie Sankt Augustin bei Bonn",
      description:
        "Kosmetikstudio und Parfümerie in Sankt Augustin Hangelar bei Bonn: Gesichtsbehandlungen, Make-up, Braut Make-up und persönliche Beratung.",
    },
    impressum: {
      title: "Impressum – Parfumhaus Hangelar Sankt Augustin",
      description:
        "Kontakt, Adresse und rechtliche Informationen zum Parfumhaus Hangelar in Sankt Augustin.",
    },
  },
};

export default seoConfig;
